import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as JobId } from '../../../job/Id';
import { Id as StageId } from '../../../job/stage/Id';
import { Id as TransactionId } from '../../../transaction/Id';

export const Params = intersect(
	struct({
		transactionId: TransactionId,
		stageId: StageId,
	})
)(
	partial({
		jobId: JobId,
	})
);
